"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeaderMenuItemsMobile = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var dropdown_menu_1 = require("../../../../dropdown-menu/dropdown-menu");
var sub_header_1 = require("../../../sub/sub-header");
var header_menu_items_style_1 = require("../header-menu-items-style");
var header_menu_items_mobile_style_1 = require("./header-menu-items-mobile-style");
function HeaderMenuItemsMobile(props) {
    var _a;
    var items = props.items, _b = props.activeItemIndex, activeItemIndex = _b === void 0 ? 0 : _b, onSelectItem = props.onSelectItem, onSelectSubItem = props.onSelectSubItem, activeSubItemIndex = props.activeSubItemIndex;
    var _c = (_a = items[activeItemIndex]) !== null && _a !== void 0 ? _a : {}, subHeaderItems = _c.subHeaderItems, subHeaderType = _c.subHeaderType;
    var firstItem = items[0], restItems = items.slice(1);
    var firstSubHeaderItems = firstItem.subHeaderItems, firstSubHeaderType = firstItem.subHeaderType, restFirstItemProps = __rest(firstItem, ["subHeaderItems", "subHeaderType"]);
    return ((0, jsx_runtime_1.jsxs)(header_menu_items_mobile_style_1.StyledHeaderMenuItemsMobile, { children: [(0, jsx_runtime_1.jsx)(header_menu_items_style_1.StyledHeaderItem, __assign({}, restFirstItemProps, { onClick: function (event) {
                    var _a;
                    onSelectItem === null || onSelectItem === void 0 ? void 0 : onSelectItem(0);
                    (_a = firstItem.onClick) === null || _a === void 0 ? void 0 : _a.call(firstItem, event);
                } })), (0, jsx_runtime_1.jsx)(header_menu_items_style_1.StyledHeaderItem, { children: (0, jsx_runtime_1.jsx)(dropdown_menu_1.DropdownMenu, { label: "More Items", text: "More Items", controls: restItems.map(function (item, index) {
                        var _a = item.title, title = _a === void 0 ? '' : _a;
                        return {
                            title: title,
                            isActive: activeItemIndex === index + 1,
                            onClick: function (event) {
                                var _a;
                                onSelectItem === null || onSelectItem === void 0 ? void 0 : onSelectItem(index + 1);
                                (_a = item.onClick) === null || _a === void 0 ? void 0 : _a.call(item, event);
                            }
                        };
                    }) }) }), (0, jsx_runtime_1.jsx)(sub_header_1.SubHeader, { subHeaderItems: subHeaderItems, subHeaderType: subHeaderType, activeItemIndex: activeSubItemIndex, onSubItemClick: function (index) {
                    onSelectSubItem === null || onSelectSubItem === void 0 ? void 0 : onSelectSubItem(index);
                } })] }));
}
exports.HeaderMenuItemsMobile = HeaderMenuItemsMobile;
